module.exports = "/static/images/logo-circle.png";